import { color } from "html2canvas/dist/types/css/types/color";

export const page = {
  products: "products",
  analitycs: "analytics",
  spot: "SPOT",
  academy: "academy",
  fiiData: "fii-data",
  about: "about",
  resource: "From REsource article"
};

export const action = {
  learnMore: "learn-more",
  requestDemo: "request-demo",
  subscribe: "subscribe-now",
  moreInfo: "more-info",
  startNow: "start-now",
  contactUs: "contact-us",
  touchs: "touchs"
};

export const captchaImg = {
  images: [
    { img: "assets/img/captcha.png", text: "xajfi" },
    { img: "assets/img/captcha1.png", text: "uejvh" },
    { img: "assets/img/captcha2.png", text: "fnjiq" },
    { img: "assets/img/captcha3.png", text: "fbsvfq" }
  ]
};

export const latLog = 0.0000000001;

export const kmlSourceBr = "https://s3-sa-east-1.amazonaws.com/siila-br-kml/";
export const kmlSourceMx = "https://siila-mx-kml.s3.us-west-1.amazonaws.com/";

export const kmlCommercial = [{ kmlUrl: kmlSourceBr + "grocs.kml" }];

export const kmlIndustrial = [
  { kmlUrl: kmlSourceBr + "industiralSOPAULO.kmz" },
  { kmlUrl: kmlSourceBr + "industrialDEJANEIRO.kmz" },
  { kmlUrl: kmlSourceBr + "industrialMINASGERAIS.kmz" },
  { kmlUrl: kmlSourceBr + "industrialAMAZONAS.kmz" },
  { kmlUrl: kmlSourceBr + "industrialBAHIA.kmz" },
  { kmlUrl: kmlSourceBr + "industrialCEAR.kmz" },
  { kmlUrl: kmlSourceBr + "industrialDISTRITOFEDERAL.kmz" },
  { kmlUrl: kmlSourceBr + "industrialESPRITOSANTO.kmz" },
  { kmlUrl: kmlSourceBr + "industrialGOI.kmz" },
  { kmlUrl: kmlSourceBr + "industrialPARAN.kmz" },
  { kmlUrl: kmlSourceBr + "INDUSTRIAL_SANTA_CATARINA.kmz" },
  { kmlUrl: kmlSourceBr + "industrialGRANDEDOSUL.kmz" },
  { kmlUrl: kmlSourceBr + "industrialPARABA.kmz" },
  { kmlUrl: kmlSourceBr + "industrialSERGIPE.kmz" },
  { kmlUrl: kmlSourceBr + "industrialPAR.kmz" },
  { kmlUrl: kmlSourceBr + "industrialPERNAMBU.kmz" }
];

export const kmlOffice = [
  { kmlUrl: kmlSourceBr + "officeCAMPINAS.kmz" },
  { kmlUrl: kmlSourceBr + "officePORTOALEGRE.kmz" },
  { kmlUrl: kmlSourceBr + "officeCURITIBA.kmz" },
  { kmlUrl: kmlSourceBr + "officeSAOPAULO_v3.kmz" },
  { kmlUrl: kmlSourceBr + "officeRIODEJANEIRO.kmz" },
  { kmlUrl: kmlSourceBr + "officeBELOHORIZONTE.kmz" },
  { kmlUrl: kmlSourceBr + "officeBRASILA.kmz" }
];

export const kmlCommercialMx = [
  { kmlUrl: kmlSourceMx + "Retail_CDMX.kmz" },
  { kmlUrl: kmlSourceMx + "Retail_Guadalajara.kmz" },
  { kmlUrl: kmlSourceMx + "Retail_Monterrey.kmz" },
  { kmlUrl: kmlSourceMx + "RetailQueretaro.kmz" }
];

export const kmlIndustrialMx = [
  { kmlUrl: kmlSourceMx + "Industrial_CDMX.kmz" },
  { kmlUrl: kmlSourceMx + "Industrial_Ciudad_Juárez.kmz" },
  { kmlUrl: kmlSourceMx + "Industrial_Guadalajara.kmz" },
  { kmlUrl: kmlSourceMx + "Industrial_Guanajuato.kmz" },
  { kmlUrl: kmlSourceMx + "Industrial_Mexicali.kmz" },
  { kmlUrl: kmlSourceMx + "Industrial_Monterrey.kmz" },
  { kmlUrl: kmlSourceMx + "Industrial_Querétaro.kmz" },
  { kmlUrl: kmlSourceMx + "Industrial_Saltillo.kmz" },
  { kmlUrl: kmlSourceMx + "Industrial_San_Luis_Potosí.kmz" },
  { kmlUrl: kmlSourceMx + "Industrial_Tijuana.kmz" },
  { kmlUrl: kmlSourceMx + "Industrial_Aguascalientes.kmz" }
];

export const kmlOfficeMx = [
  { kmlUrl: kmlSourceMx + "Office_CDMX.kmz" },
  { kmlUrl: kmlSourceMx + "Office_Guadalajara.kmz" },
  { kmlUrl: kmlSourceMx + "Office_Monterrey.kmz" },
  { kmlUrl: kmlSourceMx + "Office_Querétaro.kmz" }
];

export const apexObj = {
  series: [],
  chart: {
    height: 350,
    type: "line",
    width: "100%",
    toolbar: {
      show: true,
      tools: {
        download: true,
        zoom: true,
        zoomin: true,
        pan: false,
        zoomout: true
      }
    }
  },
  stroke: {
    curve: "smooth",
    width: 2
  },
  title: {
    text: ""
  },
  dataLabels: {
    enabled: true,
    enabledOnSeries: [1]
  },
  labels: [],
  xaxis: {
    type: "datetime"
  },
  yaxis: [
    {
      title: {
        text: "Market Rent R$"
      }
    },
    {
      opposite: true,
      min: 0,
      max: 100,
      title: {
        text: "Occupancy %"
      }
    }
  ]
};

export const apexObj2 = {
  series: [],
  chart: {
    height: 350,
    type: "line",
    width: "100%",
    toolbar: {
      show: true,
      tools: {
        download: true,
        zoom: true,
        zoomin: true,
        pan: false,
        zoomout: true
      }
    }
  },
  stroke: {
    curve: "smooth",
    width: 2
  },
  title: {
    text: ""
  },
  dataLabels: {
    enabled: true,
    enabledOnSeries: [1]
  },
  labels: [],
  xaxis: {
    type: "datetime"
  },
  yaxis: [
    {
      title: {
        text: "Market Rent R$"
      }
    },
    {
      opposite: true,
      min: 0,
      max: 100,
      title: {
        text: "Occupancy %"
      }
    }
  ]
};
